import { Button } from "./Button";
import { CancelButton } from "./CancelButton";
import { Modal } from "./Modal";
import { ConfirmationModalProps } from "./ConfirmationModal.types";

/** Asks before something is done, with Cancel on the left and the action on the right. */
export function ConfirmationModal({
  modalTitle,
  children,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isSubmitting = false,
  confirmDisabled = false,
  className,
}: ConfirmationModalProps) {
  return (
    <Modal title={modalTitle} onClose={onClose} className={className}>
      <div className="modal-body">{children}</div>
      <div className="modal-footer d-block">
        <div className="w-100 d-flex justify-content-between">
          <CancelButton onClick={onClose} text={cancelText} />
          <Button
            variant="primary"
            disabled={isSubmitting || confirmDisabled}
            onClick={onConfirm}
            showSpinner={isSubmitting}
            text={confirmText}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
